import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
var _createContextStore = createContextStore({
    productTitle: undefined
});
export var useAppSnackbarStore = _createContextStore.useStore, AppSnackbarProvider = _createContextStore.Provider;
